import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { EventProfile } from 'cb-model';
import { ControlVisibilityLimitOptions } from './ControlVisibilityLimitOptions';
import { useLocalEventProfile } from './useLocalEventProfile';

export const EventProfileUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(EventProfile, params.key);
  const { LocalEventProfile } = useLocalEventProfile();

  return (
    <>
      <PageTitle verb="Update" entity={LocalEventProfile} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/event-profile-update"
        handleCancel={() => navigate(getListRowLink(LocalEventProfile.listRowLink, params.key))}
        handleSuccess={() => navigate(getListRowLink(LocalEventProfile.listRowLink, params.key))}
        initialization={{
          main: { type: 'update-single', entity: LocalEventProfile, record },
        }}
      >
        <ControlVisibilityLimitOptions localEventProfile={LocalEventProfile} />
        <h6>Basic Details</h6>
        <Update valuesKey="main" entity={LocalEventProfile} fieldGroup="basic" />
        <h6>Event Engagement Settings</h6>
        <Update valuesKey="main" entity={LocalEventProfile} fieldGroup="engagement" />
        <h6>Audience Settings</h6>
        <Update valuesKey="main" entity={LocalEventProfile} fieldGroup="audience" />
        <h6>Post-Event Flow Settings</h6>
        <Update valuesKey="main" entity={LocalEventProfile} fieldGroup="post-event-flow" />
        <h6>Certificate Templates</h6>
        <Update valuesKey="main" entity={LocalEventProfile} fieldGroup="certificates" />
      </FormManager>
    </>
  );
};
